import {
  Alarm,
  createListAllQuery,
  graphqlCall,
  listAlarms,
  ListAlarmsQuery,
  ListAlarmsQueryVariables,
} from '@akin-home/amplify';
import { objectToQueryParams } from '@akin-home/objects';
import { API } from 'aws-amplify';

export const listAlarmsQuery = (params: ListAlarmsQueryVariables) =>
  graphqlCall<ListAlarmsQuery>(listAlarms, params);

export const listAllAlarmsQuery = createListAllQuery<
  Alarm,
  ListAlarmsQueryVariables
>(listAlarms, 'listAlarms');

export const listAllAlarmsByHabitatQuery = async (
  habitatID: string,
  filters?: { from?: string; to?: string; title?: string }
) => {
  const query_params = objectToQueryParams(filters);

  return (
    await API.get(
      'CalendarAPI',
      `/alarms/habitat/${habitatID}?${query_params}`,
      {}
    )
  ).data;
};

export const getAlarmQuery = async (id: string) => {
  return (await API.get('CalendarAPI', `/alarms/${id}`.replace('#', '%23'), {}))
    .data;
};
